

(function () {
  
    "use strict";

    // @ngInject
    function TrackControllerCtor($scope, $injector, $q, UsersManager, ModalService, AnalyticsService, moment, $sce) {
    
        this.constructor.$super.call(this, $scope, $injector);
        this.AnalyticsService = AnalyticsService;
        this.AnalyticsService.trackPageView(this, 'TrackView');
        this.__objectType = 'TrackController';
        this.moment = moment;

        this.$q = $q;
        this.UsersManager = UsersManager;
        this.ModalService = ModalService;
        this.AnalyticsService = AnalyticsService;
        this.$sce = $sce;

        this.user = UsersManager.getCurrUser();

        this.iframe_src = '';

        this.loansProgressMap = {};
        if (!!this.user.track_tax_user_id) {
            this.shouldShowConnectTrackBtn = false;
            this.getTrackToolUrl(false)
        }else{
            this.shouldShowConnectTrackBtn = true;
        }
    }

    Controllers.TrackController = Class(Controllers.BaseController, {
        constructor: TrackControllerCtor,


        getTrackToolUrl: function getTrackToolUrl(add_opt_in_date) {
            var opt_in_date = null;
            if (add_opt_in_date){
                opt_in_date = Date.now();
            }
            this.UsersManager.getTrackToolUrl(this.user, opt_in_date)
                .then(function success(resp) {
                    this.AnalyticsService.trackSuccess(this, "connect to track succeeded");
                    this.shouldShowConnectTrackBtn = false;
                    this.iframe_src = this.$sce.trustAsResourceUrl(resp.data.iframe_url);
                    var trackToolIframe = document.querySelector('#trackToolIframe');
                    var headerElement = document.querySelector('.top-view.top-view--js');

                    if (headerElement && trackToolIframe) {
                        trackToolIframe.setAttribute('style', 'height: calc(100vh - ' + (headerElement.offsetHeight + 1) + 'px');
                    }
                    this.user.track_tax_user_id = resp.data.track_tax_user_id;
                }.bind(this));

        }
    });
    
}());
